<template>
  <div>
    <a-card class="l-container mt-4 mb-4">
      <a-button @click="visible = true"  preset="card"> Start Me up </a-button>
    </a-card>

    <Modal :visible="visible" @ok="visible = false" @cancel="visible = false" class="h-5/6">
      <a-card style="max-width: 680px;" :bordered="false" class="card">
        <div class="title " >メールで送る</div>
        <div class="description1">
          <div> ご指定のメールアドレスへ、</div> 
          <div>
            情報をお送りします。
          </div>
          </div>
        <div class="description2"><span>※</span><span>下記「送信する」ボタンを押すと、即時メールが返信されます。</span></div>
        <div class="description3"><span>※</span><span>メール本文記載のURLは、PCホームページ用のURLとなります。</span></div>
        <a-input  type="text" class="input1" placeholder="メールアドレスをご入力ください。" />
        <a-input  type="text"  class="input2" placeholder="パスワードを入力" />
        <a-button size="large" class="submit-btn "><span class="title-btn">送信する</span></a-button>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  data() {
    return {
      visible: false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>